@if (hasCustomization) {
  <div class="customization-info">
    <a
      href="#"
      (click)="viewCustomization()"
      class="customization-link link link-underline color--primary-grey font-6 text-transformation-none"
      >View Customizations</a
    >
    <ul class="customization-info--list">
      @for (customItem of customizations; track customItem) {
        <li class="quantity">QTY: {{ customItem.custom_qty }}</li>
        @for (label of customItem.custom_text_fields; track label) {
          @if (label.text) {
            <li>{{ label.label }}: {{ label.text }}</li>
          }
        }
      }
    </ul>
  </div>
}
